import styled from 'styled-components'

const IntegrationFormTitle = styled.div`
	font-weight: bold;
	font-size: 30px;
	color: ${props => props.theme.textColor};
`

export default IntegrationFormTitle